// slices/academicSession.ts (though this handles academic session info)
import { createSlice } from '@reduxjs/toolkit'
import { DynamicKey } from '@school/schemas/typeInterface'
import localStorage  from '@school/common/common-utils/LocalStorage'
interface AcademicSession extends DynamicKey {
  name: string // the field we really care about
}

interface InitialProps {
  name?: string // slice state expects a string or undefined
}
// Utility function to load academic session from localStorage
const loadAcademicSession = (): AcademicSession | null => {
  try {
    const serializedState = localStorage.get('academicSession')
    return serializedState ? JSON.parse(serializedState) : null
  } catch (err) {
    console.error('Error parsing academic session:', err)
    return null
  }
}

// Initial state for the slice, preloaded from localStorage if available
const initialState: InitialProps = {
  name: loadAcademicSession() || '', // Default to empty string if not found
}

// Creating a Redux slice for academic session management
export const academicSession = createSlice({
  name: 'academicSessionFromParent', // Name of the slice
  initialState, // State defined above
  reducers: {
    // Action to set and persist academic session value
    setAcademicSessionFromParent: (state, action) => {
      state.name = action.payload
      try {
        localStorage.set('academicSession', JSON.stringify(action.payload)) // Save to localStorage
      } catch (e) {
        console.error('Could not save academicSession to localStorage', e)
      }
    },
    // Action to clear academic session from both state and localStorage
    clearAcademicSessionFromParent: (state) => {
      state.name = ''
      try {
        localStorage.delete('academicSession') // Remove from localStorage
      } catch (e) {
        console.error('Could not remove academicSession from localStorage', e)
      }
    },
  },
})

// Export actions for use in components or middleware
export const { setAcademicSessionFromParent, clearAcademicSessionFromParent } =
  academicSession.actions

// Export reducer to be added in the store
export default academicSession.reducer
